/* This is generated code, don't alter */
var IfcCoilTypeEnum;
(function (IfcCoilTypeEnum) {
    IfcCoilTypeEnum[IfcCoilTypeEnum["DXCOOLINGCOIL"] = 0] = "DXCOOLINGCOIL";
    IfcCoilTypeEnum[IfcCoilTypeEnum["ELECTRICHEATINGCOIL"] = 1] = "ELECTRICHEATINGCOIL";
    IfcCoilTypeEnum[IfcCoilTypeEnum["GASHEATINGCOIL"] = 2] = "GASHEATINGCOIL";
    IfcCoilTypeEnum[IfcCoilTypeEnum["HYDRONICCOIL"] = 3] = "HYDRONICCOIL";
    IfcCoilTypeEnum[IfcCoilTypeEnum["STEAMHEATINGCOIL"] = 4] = "STEAMHEATINGCOIL";
    IfcCoilTypeEnum[IfcCoilTypeEnum["WATERCOOLINGCOIL"] = 5] = "WATERCOOLINGCOIL";
    IfcCoilTypeEnum[IfcCoilTypeEnum["WATERHEATINGCOIL"] = 6] = "WATERHEATINGCOIL";
    IfcCoilTypeEnum[IfcCoilTypeEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcCoilTypeEnum[IfcCoilTypeEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcCoilTypeEnum || (IfcCoilTypeEnum = {}));
const IfcCoilTypeEnumCount = 9;
export { IfcCoilTypeEnum, IfcCoilTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcCoilTypeEnum = new Int32Array([2, -6, 21]);
let prefixSumAddressIfcCoilTypeEnum = new Uint32Array([0, 18, 36, 52, 66, 87, 99, 114, 132, 145]);
let slotMapIfcCoilTypeEnum = new Int32Array([5, 4, 2, 3, 1, 8, 0, 6, 7]);
let encodedDataIfcCoilTypeEnum = (new TextEncoder()).encode(".WATERCOOLINGCOIL..STEAMHEATINGCOIL..GASHEATINGCOIL..HYDRONICCOIL..ELECTRICHEATINGCOIL..NOTDEFINED..DXCOOLINGCOIL..WATERHEATINGCOIL..USERDEFINED.");
let IfcCoilTypeEnumSearch = new MinimalPerfectHash(gMapIfcCoilTypeEnum, prefixSumAddressIfcCoilTypeEnum, slotMapIfcCoilTypeEnum, encodedDataIfcCoilTypeEnum);
export { IfcCoilTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcCoilTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcCoilTypeEnumSearch, input, cursor, endCursor);
}
